export const SETTLEMENT_BATCH_PENDING_REFRESH_EVENT = "flymeta:settlement-batch-pending-refresh";

/**
 * 通知侧栏立即重新获取批次待处理数量。
 *
 * 仅在后端确认有批次被标记为 NEEDS_RECALCULATION 时触发，保留定时轮询作为兜底。
 */
export function refreshSettlementBatchPending(affectedBatchIds = []) {
    if (typeof window === "undefined" || affectedBatchIds.length === 0) {
        return;
    }

    window.dispatchEvent(new Event(SETTLEMENT_BATCH_PENDING_REFRESH_EVENT));
}
